import styled, { keyframes } from 'styled-components';

// Animações suaves
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f6f8fb;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  z-index: 2000;
  padding: 0;
  animation: ${fadeIn} 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  height: 100dvh;
  overflow: hidden;

  @media (max-width: 1024px) {
    background: #ffffff;
  }
`;

export const ModalContainer = styled.div`
  background: #ffffff;
  border-radius: 0;
  max-width: none;
  width: 100vw;
  height: 100dvh;
  max-height: none;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  box-shadow: none;
  overflow: hidden;
  border: none;

  @media (max-width: 1024px) {
    width: 100vw;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 48px;
  background: #4285f4;
  color: white;
  flex-shrink: 0;
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.18);

  @media (max-width: 1024px) {
    padding: 20px 24px;
  }

  @media (max-width: 768px) {
    padding: 16px 20px;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  z-index: 1;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const HeaderIcon = styled.div`
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  
  .material-icons {
    font-size: 32px;
    color: white;
  }

  @media (max-width: 768px) {
    width: 44px;
    height: 44px;
    border-radius: 12px;

    .material-icons {
      font-size: 24px;
    }
  }
`;

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ModalTitle = styled.h2`
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin: 0;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 1024px) {
    font-size: 24px;
  }

  @media (max-width: 768px) {
    font-size: 20px;
    letter-spacing: -0.3px;
  }
`;

export const ModalSubtitle = styled.p`
  font-size: 15px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.95);
  margin: 0;

  @media (max-width: 768px) {
    font-size: 13px;
    display: none; /* Oculta em mobile para economizar espaço */
  }
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  cursor: pointer;
  color: white;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: rotate(90deg) scale(1.1);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: rotate(90deg) scale(0.95);
  }

  .material-icons {
    font-size: 28px;
  }

  @media (max-width: 768px) {
    width: 44px;
    height: 44px;
    border-radius: 10px;

    .material-icons {
      font-size: 24px;
    }

    &:hover {
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.95);
    }
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 4px;
  background: #ffffff;
  padding: 10px 48px;
  overflow-x: auto;
  flex-shrink: 0;
  box-shadow: none;
  border-bottom: 1px solid #e5e7eb;
  align-items: center;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f3f4;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #bdc1c6;
    border-radius: 3px;
  }

  @media (max-width: 1024px) {
    padding: 10px 24px;
    gap: 2px;
  }

  @media (max-width: 768px) {
    padding: 12px 8px;
    gap: 8px;
    justify-content: space-between;
    overflow-x: auto;
    overflow-y: hidden;

    &::-webkit-scrollbar {
      height: 3px;
    }
  }
`;

export const Tab = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  border: none;
  background: ${(props) => props.$active ? '#e8f0fe' : 'transparent'};
  color: ${(props) => props.$active ? '#1a73e8' : '#5f6368'};
  font-size: 13px;
  font-weight: ${(props) => props.$active ? '600' : '500'};
  cursor: pointer;
  border-radius: 10px;
  white-space: nowrap;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  flex-shrink: 0;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: ${(props) => props.$active ? '80%' : '0'};
    height: 3px;
    background: #4285f4;
    border-radius: 2px 2px 0 0;
    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover {
    background: ${(props) => props.$active ? '#e8f0fe' : 'rgba(26, 115, 232, 0.06)'};
    transform: none;
  }

  &:active {
    transform: translateY(0);
  }

  .material-icons {
    font-size: 20px;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    flex-shrink: 0;
  }

  &:hover .material-icons {
    transform: none;
  }

  @media (max-width: 1024px) {
    padding: 10px 16px;
    font-size: 12px;
    gap: 6px;

    .material-icons {
      font-size: 18px;
    }
  }

  @media (max-width: 768px) {
    padding: 12px 8px;
    font-size: 0;
    gap: 0;
    border-radius: 8px;
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .material-icons {
      font-size: 28px;
      margin: 0;
    }

    &:hover {
      transform: none;
      background: ${(props) => props.$active ? '#e8f0fe' : 'rgba(26, 115, 232, 0.1)'};
    }
    
    &:active {
      background: ${(props) => props.$active ? '#e8f0fe' : 'rgba(26, 115, 232, 0.12)'};
    }
  }
`;


export const ModalBody = styled.div`
  padding: 32px 48px 40px 48px;
  overflow-y: auto !important;
  overflow-x: hidden;
  flex: 1 1 auto;
  background: #f6f8fb;
  min-height: 0;
  position: relative;
  max-height: none;

  @media (max-width: 768px) {
    padding: 20px 16px;
    max-height: none;
  }

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #f8f9fa;
    border-radius: 10px;
    margin: 8px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: #bdc1c6;
    border-radius: 10px;
    border: 3px solid #f8f9fa;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #9aa0a6;
  }

  /* Melhoria para textos longos */
  p, span, div {
    word-break: break-word;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }

  @media (max-width: 1024px) {
    padding: 28px 24px;

    &::-webkit-scrollbar {
      width: 8px;
    }
  }

  @media (max-width: 768px) {
    padding: 20px 16px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      border: 2px solid #f8f9fa;
    }
  }
`;

export const FormSection = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  min-height: min-content;
  padding: 32px 36px 48px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);

  @media (max-width: 1024px) {
    max-width: 100%;
    padding: 28px 28px 40px;
  }

  @media (max-width: 768px) {
    padding: 20px 16px 32px;
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #202124;
  margin: 0 0 32px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  
  &::before {
    content: '';
    width: 4px;
    height: 24px;
    background: #4285f4;
    border-radius: 2px;
  }

  @media (max-width: 1024px) {
    font-size: 18px;
    margin: 0 0 24px 0;

    &::before {
      height: 20px;
    }
  }

  @media (max-width: 768px) {
    font-size: 17px;
    margin: 0 0 20px 0;
    gap: 10px;

    &::before {
      width: 3px;
      height: 18px;
    }
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 28px;
  margin-bottom: 28px;
  width: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px;
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
    margin-bottom: 20px;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 28px;
  animation: ${slideUp} 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  animation-fill-mode: both;

  &:nth-child(1) { animation-delay: 0.05s; }
  &:nth-child(2) { animation-delay: 0.1s; }
  &:nth-child(3) { animation-delay: 0.15s; }
  &:nth-child(4) { animation-delay: 0.2s; }
  &:nth-child(5) { animation-delay: 0.25s; }
  &:nth-child(6) { animation-delay: 0.3s; }
  &:nth-child(7) { animation-delay: 0.35s; }

  @media (max-width: 1024px) {
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    margin-bottom: 20px;
    animation: none; /* Remove animações no mobile para performance */
  }
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #202124;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  .material-icons {
    font-size: 18px;
    color: #1a73e8;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    gap: 6px;
    margin-bottom: 8px;

    .material-icons {
      font-size: 16px;
    }
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 14px 18px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  font-size: 15px;
  color: #202124;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
  font-family: inherit;
  background: white;

  &:hover {
    border-color: #bdc1c6;
  }

  &:focus {
    outline: none;
    border-color: #1a73e8;
    box-shadow: 0 0 0 4px rgba(26, 115, 232, 0.12);
    transform: translateY(-1px);
  }

  &:disabled {
    background: #f1f3f4;
    color: #80868b;
    cursor: not-allowed;
    border-color: #e8eaed;
  }

  &::placeholder {
    color: #9aa0a6;
    font-weight: 400;
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
    font-size: 14px;
    border-radius: 10px;

    &:focus {
      box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.12);
      transform: none;
    }
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 14px 18px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  font-size: 15px;
  color: #202124;
  background: white;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
  font-family: inherit;

  &:hover {
    border-color: #bdc1c6;
  }

  &:focus {
    outline: none;
    border-color: #1a73e8;
    box-shadow: 0 0 0 4px rgba(26, 115, 232, 0.12);
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
    font-size: 14px;
    border-radius: 10px;

    &:focus {
      box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.12);
    }
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 14px 18px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  font-size: 15px;
  color: #202124;
  font-family: inherit;
  resize: vertical;
  min-height: 160px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
  line-height: 1.6;
  background: white;

  &:hover {
    border-color: #bdc1c6;
  }

  &:focus {
    outline: none;
    border-color: #1a73e8;
    box-shadow: 0 0 0 4px rgba(26, 115, 232, 0.12);
  }

  &::placeholder {
    color: #9aa0a6;
    font-weight: 400;
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
    font-size: 14px;
    border-radius: 10px;
    min-height: 120px;

    &:focus {
      box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.12);
    }
  }
`;

export const CharCounter = styled.div<{ $overLimit?: boolean }>`
  text-align: right;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.$overLimit ? '#ea4335' : '#5f6368'};
  transition: color 0.3s ease;
`;

export const StatCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  background: #f8f9fa;
  border-radius: 16px;
  margin-bottom: 16px;
  border: 2px solid #f1f3f4;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    border-color: #e8eaed;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StatLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  color: #5f6368;

  .material-icons {
    font-size: 24px;
    color: #1a73e8;
  }
`;

export const StatValue = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: #4285f4;
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 48px;
  border-top: 1px solid #e0e0e0;
  background: #ffffff;
  flex-shrink: 0;
  box-shadow: 0 -1px 8px rgba(15, 23, 42, 0.06);
  position: relative;
  z-index: 10;

  @media (max-width: 1024px) {
    padding: 18px 24px;
    gap: 12px;
  }

  @media (max-width: 768px) {
    padding: 16px;
    flex-direction: column;
    gap: 12px;
    /* position: sticky; removido pois o layout flex já garante o footer no final */
    /* bottom: 0; */
  }
`;

export const FooterInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #5f6368;
  font-size: 13px;
  font-weight: 500;
  
  .material-icons {
    font-size: 20px;
    color: #1a73e8;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    display: none; /* Oculta em mobile para economizar espaço */
  }
`;

export const SaveFeedback = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 520px;
  padding: 10px 12px;
  border: 1px solid #fecaca;
  border-radius: 10px;
  background: #fef2f2;
  color: #991b1b;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;

  .material-icons {
    color: #dc2626;
    font-size: 18px;
  }

  @media (max-width: 1024px) {
    max-width: 100%;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: 768px) {
    width: 100%;
    gap: 8px;
  }
`;

export const Button = styled.button<{ $secondary?: boolean }>`
  padding: 14px 32px;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.4);
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
  }

  &:hover::before {
    width: 400px;
    height: 400px;
  }

  .material-icons {
    font-size: 20px;
    position: relative;
    z-index: 1;
  }

  span:not(.material-icons) {
    position: relative;
    z-index: 1;
  }

  ${(props) => props.$secondary ? `
    background: white;
    color: #5f6368;
    border: 2px solid #e0e0e0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    &:hover {
      border-color: #bdc1c6;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }
  ` : `
    background: #4285f4;
    color: white;
    box-shadow: 0 2px 8px rgba(66, 133, 244, 0.3);

    &:hover {
      background: #1a73e8;
      box-shadow: 0 4px 12px rgba(66, 133, 244, 0.4);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(66, 133, 244, 0.3);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }
  `}

  @media (max-width: 768px) {
    padding: 12px 24px;
    font-size: 14px;
    border-radius: 10px;
    gap: 8px;
    flex: 1;
    justify-content: center;

    .material-icons {
      font-size: 18px;
    }

    &:hover::before {
      width: 0;
      height: 0;
    }

    ${(props) => !props.$secondary && `
      &:hover {
        transform: none;
        box-shadow: 0 2px 8px rgba(66, 133, 244, 0.3);
      }
    `}

    ${(props) => props.$secondary && `
      &:hover {
        transform: none;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      }
    `}
  }
`;
